import { useEffect } from "react";
const useOnClickOutside = (ref, handler, isChildOverlay) => {
  useEffect(() => {
    const listener = (event) => {
      if (!isChildOverlay && document.querySelector("[data-overlay-is-child]")) {
        return;
      }
      if (!ref.current || ref.current.contains(event.target)) {
        return;
      }
      handler(event);
    };
    document.addEventListener("click", listener);
    document.addEventListener("touchstart", listener);
    return () => {
      document.removeEventListener("click", listener);
      document.removeEventListener("touchstart", listener);
    };
  }, [ref, isChildOverlay]);
};
var useClickOutside_default = useOnClickOutside;
export {
  useClickOutside_default as default
};
